import {Classes, Overlay} from '@blueprintjs/core';
import React from 'react';
import toastr from 'toastr';
import Form from '../../components/common/Form';
import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InputRegular from '../common/InputRegular';

class DeleteTagModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                tagId: props.tagId,
                tagName: props.tagName
            },
            overlayIsOpen: false
        };
    }

    doSubmit = async (e) => {
        this.setState({spinnerActive: true})
        let projectId = await this.props.projectId ? this.props.projectId : JSON.parse(localStorage.source_clicked);
        let phoneId = await this.props.phoneId;

        try {
            if(this.props.deleteVerifiedPhone){
                const result = await http.delete('/api/user/' + this.props.user.id + '/project/' + projectId + '/verified_phones/' + phoneId + '/page_size/10', {headers: {authorization: getJwt()}});
                if (result) {
                    this.setState({spinnerActive: false})
                    this.props.handleClose()
                    toastr.success('Phone number successfully deleted');
                    this.props.getNumbers()
                }
            }else{
                const result = await http.delete('/api/project/' + projectId + '/phone/' + phoneId, {headers: {authorization: getJwt()}});
                if (result) {
                    this.setState({spinnerActive: false})
                    this.props.handleClose()
                    toastr.success('Phone number successfully deleted');
                    this.props.getNumbers()
                }
            }

        } catch (e) {
            toastr.error('Error Code #10013: Delete of the phone number was unsuccessful. Please try again.')
            this.setState({spinnerActive: false})
        }
    };


    render() {
        let {visible_modal, onClickAway} = this.props;

        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment"
                     style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>Delete phone number</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>
                            <span>Are you sure you want to delete phone number?
                            </span>
                            </div>
                            <div className='justify-content-end flex-direction-row margin-bottom-20'>

                                <button disabled={false}
                                        onClick={this.props.handleClose}
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className="btn-white-border margin-right-10">Cancel
                                </button>
                                {!this.state.spinnerActive ?
                                    <button disabled={false}
                                            name="delete_tag"
                                            id="delete_tag"
                                            type="button"
                                            onClick={this.doSubmit}
                                            className="btn-danger">Delete</button>
                                    :
                                    <button disabled={false}
                                            name="delete_tag"
                                            id="delete_tag"
                                            type="button"
                                            onClick={this.doSubmit}
                                            className="btn-danger btn-spinner">Delete <i
                                        className='fa fa-spin fa-spinner'></i></button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}

export default DeleteTagModal;